<template>
  <div class="legal-page">
    <page-cover :cover="cover" v-if="cover" />
    <Legal />
  </div>
</template>

<script>
import PageCover from "@/components/shared/PageCover.vue";
import Legal from "@/components/legal/Legal.vue";
import { mapGetters } from "vuex";

export default {
  name: "legal",
  computed: {
    ...mapGetters({
      cover: "pageCover/getLegal", // <-- using the new getter
    }),
  },
  components: {
    PageCover,
    Legal,
  },
};
</script>
